import type { PayerBase, TransactionItemDetail } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UserLink, UserPopover } from 'features/users/components';
import { UserSimpleContent } from './user-simple-content';

type P = {
  transactionItem: TransactionItemDetail;
  user: PayerBase;
};

const UserSimple = ({ user, ...rest }: P) => {
  if (user.id) {
    return (
      // TS doesn't narrow optional id on object, so we recreate it with required id
      <UserPopover popoverProps={{ stretch: true }} user={{ ...user, id: user.id }}>
        <UserLink userId={user.id}>
          <UserSimpleContent user={user} {...rest} />
        </UserLink>
      </UserPopover>
    );
  }

  return <UserSimpleContent {...rest} user={user} />;
};

export default UserSimple;
